exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-box[data-v-3da2f15a] {\n  max-width: 300px;\n}\n.alert[data-v-3da2f15a] {\n  padding: 10px 15px;\n  border-radius: 4px;\n}\n.alert-success[data-v-3da2f15a] {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n.alert-danger[data-v-3da2f15a] {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n", ""]);

// exports
